/* eslint-disable eqeqeq */

import React, { useState, useEffect } from "react";
import EmployerMenu from "../Components/EmployerMenus";
import SupportMenu from "../Components/SupportMenus";
import SeekerMenu from "../Components/SeekerMenu";
import GroupLeaderMenu from "../Components/GroupLeaderMenu";
import logoimage from "../assests/img/JIN_logo.svg";
import { useSelector } from "react-redux";
import { getUserDetails } from "../Services/GetFields";
import AdminMenu from "./AdminMenu";
import { Roles } from "../Utilities/Helper";
import { getData } from "../Utilities/StorageHelper";

export default function Sidebar({
  isOpen,
  toggle,
  imageChange,
  imagetoggle,
  setToggleFalse,
}) {
  const [show, setShow] = useState("");

  useEffect(() => {
    let isLoggedIn = getData("token");
    if (getData("role") === Roles.jobSeeker) {
      if (isLoggedIn) {
        getUserDetails()
          .then((res) => {
            let response = res.response.isSponsered;
            setShow(response);
          })
          .catch((err) => {
            console.log(err);
          });

      } else {
        console.log("Signed out");
      }
    }
  }, [imageChange]);

  const todo = useSelector((state) => state.login.loginData);

  const role = todo;

  return (
    <div className={isOpen ? "sidebar is-open" : "sidebar"}>
      <div className="sidebar-header">
        <img className="img-fluid" src={logoimage} alt="JIN Logo" />
      </div>

      {role?.action?.action == "first" && (
        <>
          <h5>Employer Menu</h5>
          {<EmployerMenu setToggleFalse={setToggleFalse} />}
        </>
      )}
      {role?.action?.action == "second" && (
        <>
          <h5 style={{ textAlign: "center" }}>Support Team Member Menu</h5>
          {<SupportMenu setToggleFalse={setToggleFalse} />}
        </>
      )}
      {role?.action?.action == "third" && (
        <>
          <h5>Job Seeker Menu</h5>
          {<SeekerMenu show={show} setToggleFalse={setToggleFalse} />}
        </>
      )}
      {role?.action?.action == "fourth" && (
        <>
          <h5>Group Leader Menu</h5>
          {<GroupLeaderMenu setToggleFalse={setToggleFalse} />}
        </>
      )}
      {role?.action?.action == "five" && (
        <>
          <h5>Administrator</h5>
          {<AdminMenu setToggleFalse={setToggleFalse} />}
        </>
      )}
    </div>
  );
}
